"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timingEvent = exports.pageviewEvent = exports.interactionEvent = exports.dataInitializedEvent = exports.createMapStateToAnalytics = exports.basicEvent = void 0;
var _analytics = require("../modules/analytics");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var basicEvent = exports.basicEvent = function basicEvent(eventType) {
  var appData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var coreData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    eventType: eventType,
    appData: _objectSpread({
      dimensions: {},
      appDimensions: {}
    }, appData),
    coreData: coreData
  };
};
var pageviewEvent = exports.pageviewEvent = function pageviewEvent() {
  var appData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var coreData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return basicEvent(_analytics.PAGE_VIEW, appData, coreData);
};
var dataInitializedEvent = exports.dataInitializedEvent = function dataInitializedEvent() {
  var appData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return basicEvent(_analytics.DATA_INITIALIZED, _objectSpread({
    elementPath: [],
    elementType: 'data-loaded',
    action: 'data-loaded'
  }, appData));
};
var interactionEvent = exports.interactionEvent = function interactionEvent() {
  var appData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return basicEvent(_analytics.INTERACTION, appData);
};
var timingEvent = exports.timingEvent = function timingEvent() {
  var appData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return basicEvent(_analytics.TIMING, appData);
};
var createMapStateToAnalytics = exports.createMapStateToAnalytics = function createMapStateToAnalytics(_ref) {
  var applicationName = _ref.applicationName,
    _ref$dataInitializedE = _ref.dataInitializedEventActions,
    dataInitializedEventActions = _ref$dataInitializedE === void 0 ? {} : _ref$dataInitializedE,
    _ref$interactionEvent = _ref.interactionEventActions,
    interactionEventActions = _ref$interactionEvent === void 0 ? {} : _ref$interactionEvent,
    _ref$timingEventActio = _ref.timingEventActions,
    timingEventActions = _ref$timingEventActio === void 0 ? {} : _ref$timingEventActio,
    _ref$getAppDimensions = _ref.getAppDimensions,
    getAppDimensions = _ref$getAppDimensions === void 0 ? function () {
      return {};
    } : _ref$getAppDimensions;
  if (!applicationName) {
    console.warn('No application name given for analytics');
  }
  if (!dataInitializedEventActions && !interactionEventActions && !timingEventActions) {
    console.warn('No actions configured for analytics events');
  }
  var callEventAction = function callEventAction(state, action, eventAction, getMeta) {
    var actionAppData = eventAction(action, state);
    if (actionAppData === false) {
      return false;
    }
    return getMeta(_objectSpread({
      applicationName: applicationName,
      appDimensions: getAppDimensions(state)
    }, actionAppData));
  };
  return function (state, action, events) {
    if (interactionEventActions[action.type]) {
      return callEventAction(state, action, interactionEventActions[action.type], events.interactionEvent);
    }
    if (timingEventActions[action.type]) {
      return callEventAction(state, action, timingEventActions[action.type], events.timingEvent);
    }
    if (dataInitializedEventActions[action.type]) {
      return callEventAction(state, action, dataInitializedEventActions[action.type], events.dataInitializedEvent);
    }
    return null;
  };
};